//temporary for call checkstock from store
import axios from '@/axios.js'

export default {    
  checkStock({ commit }, payload) {
    
    return new Promise((resolve, reject) => {
      
      
      axios.post('sales-and-purchase/drcc/check-stock', payload).then((response) => {
        resolve(response.data)
      }).catch((e) => {
        console.log(e)
        reject(e)
      });
    });
  },
}
